import { Clock, Star, Users } from 'lucide-react';
import { useState } from 'react';

import { PreferenciasTab } from '@/features/admin/relatorios/components/PreferenciasTab';
import { TempoAtivoTab } from '@/features/admin/relatorios/components/TempoAtivoTab';
import { UsoPorUsuarioTab } from '@/features/admin/relatorios/components/UsoPorUsuarioTab';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/ui/tabs';

type Aba = 'uso' | 'tempo-ativo' | 'preferencias';

/**
 * "Relatórios" (B15/F7) — três frentes decididas no planejamento (DEC-6/DEC-7):
 * uso por usuário (dado que já existia), tempo ativo (heartbeat) e
 * preferências (ranking de módulos por volume).
 */
export function RelatoriosPage() {
  const [aba, setAba] = useState<Aba>('uso');

  return (
    <div className="space-y-6">
      <Tabs value={aba} onValueChange={(v) => setAba(v as Aba)}>
        <TabsList>
          <TabsTrigger value="uso">
            <Users className="w-4 h-4" />
            Uso por usuário
          </TabsTrigger>
          <TabsTrigger value="tempo-ativo">
            <Clock className="w-4 h-4" />
            Tempo ativo
          </TabsTrigger>
          <TabsTrigger value="preferencias">
            <Star className="w-4 h-4" />
            Preferências
          </TabsTrigger>
        </TabsList>

        <TabsContent value="uso">
          <UsoPorUsuarioTab />
        </TabsContent>

        <TabsContent value="tempo-ativo">
          <TempoAtivoTab />
        </TabsContent>

        <TabsContent value="preferencias">
          <PreferenciasTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
